export default __webpack_public_path__ + "assets/images/534.webp";